import toggleClass from 'utils/DOM/toggleClass'
import isEpicPlan from 'utils/pivot/plan/isEpicPlan'
import isRXPlan from 'utils/pivot/plan/isRXPlan'

function setPennsylvaniaEpicPlanSBC<T extends CorePlan>(stateAcronym: string, plan: T) {
  if (stateAcronym !== 'PA' || !isEpicPlan(plan)) return

  toggleClass('body', 'pa-epic')

  toggleClass('body', 'rx', isRXPlan(plan))
}

export default setPennsylvaniaEpicPlanSBC
